import type { ImageCollection } from "common/types/imageCollection";
import { unsafelyKeys } from "common/utilities/object";

export const getPersistedImages = (newImages: ImageCollection, existingImages: ImageCollection) =>
  unsafelyKeys(newImages).reduce((accumulator, next) => {
    const newUrl = new URL(newImages[next]);
    const existingUrl = new URL(existingImages[next]);
    const match = newUrl.origin === existingUrl.origin && newUrl.pathname === existingUrl.pathname;
    return { ...accumulator, [next]: match ? existingImages[next] : newImages[next] };
  }, {} as ImageCollection);
